import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    title: {
        color: '#cb4982',
        borderBottom: '1px solid #cb4982',
        marginBottom: '16px'
        }
    })
)

const ExamTitle = ({ type, title, description }) => {
    const classes = useStyles();

    return (
        <Typography gutterBottom variant="h5" component="h1" className={classes.title}>
            {title !== undefined ? type + ' - ' + title : type}
        </Typography>
    )
}

export default ExamTitle